var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "module/main/store/hooks";
import { useLocation } from "react-router-dom";
// components
import AccountInfoPannel from "./components/AccountInfoPannel";
import OverviewPannel from "./components/OverviewPannel";
import LoadingSpinner from "module/common/components/LoadingSpinner";
import SideNav from "../HomePage/components/SideNav/SideNav";
import PlanRow from "./components/PlanRow";
import DncAddOnRow from "./components/DncAddOnRow";
import CurrentUsageBlocks from "./components/CurrentUsageBlocks";
import UsageBlocksTable from "./components/UsageBlocksTable";
import BillingPanel from "./components/BillingPanel";
import BillingInfoModal from "./components/BillingInfoModal";
import Switch from "module/common/components/Switch/Switch";
import SubscriptionCancelModal from "./components/SubscriptionCancelModal";
import SubscriptionManageModal from "./components/SubscriptionManageModal";
import UsageBlockManageModal from "./components/UsageBlockManageModal";
import DncAddOnManageModal from "./components/DncAddOnManageModal";
import PlandAndAddonCard from "./components/PlandAndAddonCard";
import { Panel, SectionTitle } from "./utils";
// store
import { addErrorToast, addSuccessToast } from "module/main/store/toast/reducer";
import { callGetApiKeys, callPatchAccount, callPatchUser } from "module/main/store/auth/thunk";
import ApiKeyPanel from "./components/ApiKeyPannel";
import { setSubscription, setUserInfo } from "module/main/store/auth/reducer";
import { selectAddOns, selectApiKeys, selectPlans, selectSubscription, selectUsageBlockOptions, selectUserInfo, } from "module/main/store/auth/selectors";
import { getChargeHistoryURL, postDowngradeSubscription, postCancelAddon, postDowngradeAddon, postPurchaseAddon, postPurchaseSubscription, postPurchaseUsageBlock, postCancelSubscription, postUndoCancelSubscription, postUndoCancelAddon, postUpgradeAddon, postUpgradeSubscription, } from "module/main/store/auth/api";
// utils
import { formatErrorMessage } from "module/common/utils";
import { gtmPush } from "module/main/util";
var Account = function () {
    var _a;
    var dispatch = useAppDispatch();
    var userInfo = useSelector(selectUserInfo);
    var apiKeys = useSelector(selectApiKeys);
    var plans = useSelector(selectPlans);
    var subscription = useSelector(selectSubscription);
    var usageBlockOptions = useSelector(selectUsageBlockOptions);
    var addOnOptions = useSelector(selectAddOns);
    var location = useLocation();
    var contentRef = useRef(null);
    var _b = useState(null), selectedPlan = _b[0], setSelectedPlan = _b[1];
    var _c = useState(null), selectedPlanAction = _c[0], setSelectedPlanAction = _c[1];
    var _d = useState(null), selectedUsageBlock = _d[0], setSelectedUsageBlock = _d[1];
    var _e = useState(null), selectedAddOn = _e[0], setSelectedAddOn = _e[1];
    var _f = useState(null), selectedAddOnAction = _f[0], setSelectedAddOnAction = _f[1];
    var _g = useState(false), isModalActionLoading = _g[0], setIsModalActionLoading = _g[1];
    var _h = useState(false), isSubCancelModalOpen = _h[0], setIsSubCancelModalOpen = _h[1];
    var _j = useState(false), isBillingInfoModalOpen = _j[0], setIsBillingInfoModalOpen = _j[1];
    var _k = useState(false), hasLocalBillingInfo = _k[0], setHasLocalBillingInfo = _k[1];
    var _l = useState(null), modalError = _l[0], setModalError = _l[1];
    var liveKey = useMemo(function () { return apiKeys === null || apiKeys === void 0 ? void 0 : apiKeys.find(function (key) { return key.isLive; }); }, [apiKeys]);
    var testKey = useMemo(function () { return apiKeys === null || apiKeys === void 0 ? void 0 : apiKeys.find(function (key) { return !key.isLive || key.keyType === "test"; }); }, [apiKeys]);
    var currentPlan = useMemo(function () { return (plans === null || plans === void 0 ? void 0 : plans.find(function (plan) { return plan.id === (subscription === null || subscription === void 0 ? void 0 : subscription.planId); })) || null; }, [plans, subscription]);
    var isPayingCustomer = !!currentPlan;
    var isCustomPlan = (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.id) === "api_custom_contract";
    var subscriptionIsCancelled = !!(subscription === null || subscription === void 0 ? void 0 : subscription.numberOfBillingCycles);
    var currentSubAddOn = ((_a = subscription === null || subscription === void 0 ? void 0 : subscription.addOns) === null || _a === void 0 ? void 0 : _a[0]) || null;
    var currentSubAddOnId = currentSubAddOn === null || currentSubAddOn === void 0 ? void 0 : currentSubAddOn.id;
    var addOnIsCancelled = !!currentSubAddOn && currentSubAddOn.numberOfBillingCycles !== null;
    var hasUsageBlockAccess = !!currentPlan && !!(apiKeys === null || apiKeys === void 0 ? void 0 : apiKeys.some(function (key) { return key.isLive && key.monthlyAllocation !== null; }));
    var activeUsageBlocks = useMemo(function () {
        return hasUsageBlockAccess ? ((liveKey === null || liveKey === void 0 ? void 0 : liveKey.usageBlocks) || []).filter(function (block) { return block.isActive; }) : [];
    }, [hasUsageBlockAccess, liveKey]);
    var hasBillingInfo = isPayingCustomer || hasLocalBillingInfo;
    var planRowIds = isCustomPlan
        ? ["api_custom_contract"]
        : ["api_payg", "api_payg_plus", "api_custom_contract"];
    useEffect(function () {
        if (!location.hash || !userInfo)
            return;
        var scrollToTarget = function () {
            var container = contentRef.current;
            var el = document.querySelector(location.hash);
            if (!container || !el)
                return;
            var containerRect = container.getBoundingClientRect();
            var elRect = el.getBoundingClientRect();
            var top = elRect.top - containerRect.top + container.scrollTop - 16;
            container.scrollTo({
                top: top,
                behavior: "smooth",
            });
        };
        var t = window.setTimeout(scrollToTarget, 0);
        return function () { return window.clearTimeout(t); };
    }, [location.hash, userInfo]);
    useEffect(function () {
        if (userInfo && !userInfo.chargeHistoryURL)
            getChargeHistoryURL().then(function (_a) {
                var data = _a.data;
                dispatch(setUserInfo(__assign(__assign({}, userInfo), { chargeHistoryURL: data })));
            });
    }, [subscription]);
    if (!userInfo) {
        return (_jsx("div", { className: "pt-10", children: _jsx(LoadingSpinner, { color: "primary", className: "mx-auto h-11 w-11" }) }));
    }
    var onToggleOptOut = function () {
        dispatch(callPatchUser({ emailOptOut: !userInfo.emailOptOut }));
        dispatch(addSuccessToast("Email settings changed."));
    };
    var closePlanModal = function () {
        setSelectedPlan(null);
        setSelectedPlanAction(null);
        setModalError(null);
    };
    var closeSubCancelModal = function () {
        setIsSubCancelModalOpen(false);
        setModalError(null);
    };
    var closeAddOnModal = function () {
        setSelectedAddOn(null);
        setSelectedAddOnAction(null);
        setModalError(null);
    };
    var closeUsageBlockModal = function () {
        setSelectedUsageBlock(null);
        setModalError(null);
    };
    var onSelectPlan = function (planId) {
        if (subscriptionIsCancelled || isCustomPlan)
            return;
        if (planId === "api_custom_contract") {
            window.location.href =
                "mailto:sales@leadsherpa.com?subject=Skip%20Sherpa%20custom%20API%20plan";
            return;
        }
        var targetPlan = plans === null || plans === void 0 ? void 0 : plans.find(function (plan) { return plan.id === planId; });
        if (!targetPlan || (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.id) === planId)
            return;
        setModalError(null);
        setSelectedPlan(targetPlan);
        setSelectedPlanAction(currentPlan ? "modify" : "purchase");
    };
    var onPurchaseSubscription = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!selectedPlan)
                return [2 /*return*/, Promise.resolve()];
            return [2 /*return*/, postPurchaseSubscription({ planId: selectedPlan.id })
                    .then(function (_a) {
                    var data = _a.data;
                    dispatch(setSubscription(data));
                    dispatch(callGetApiKeys());
                    gtmPush("purchase", {
                        currency: "USD",
                        transaction_id: crypto.randomUUID(),
                        value: selectedPlan.price,
                        items: [{ item_id: selectedPlan.id, quantity: 1, price: selectedPlan.price }],
                    });
                    dispatch(addSuccessToast("Subscription has been purchased."));
                    closePlanModal();
                })
                    .catch(function (error) {
                    var message = formatErrorMessage(error);
                    setModalError(message);
                    dispatch(addErrorToast(message));
                })];
        });
    }); };
    var onModifySubscription = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isUpgrade, method;
        return __generator(this, function (_a) {
            if (!currentPlan || !selectedPlan)
                return [2 /*return*/, Promise.resolve()];
            isUpgrade = currentPlan.id === "api_payg" && selectedPlan.id === "api_payg_plus";
            method = isUpgrade ? postUpgradeSubscription : postDowngradeSubscription;
            setIsModalActionLoading(true);
            return [2 /*return*/, method()
                    .then(function (_a) {
                    var data = _a.data;
                    dispatch(setSubscription(data));
                    dispatch(callGetApiKeys());
                    dispatch(addSuccessToast("Subscription modified."));
                    closePlanModal();
                })
                    .catch(function (error) {
                    var message = formatErrorMessage(error);
                    setModalError(message);
                    dispatch(addErrorToast(message));
                })
                    .finally(function () { return setIsModalActionLoading(false); })];
        });
    }); };
    var onPurchaseUsageBlock = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!selectedUsageBlock)
                return [2 /*return*/, Promise.resolve()];
            return [2 /*return*/, postPurchaseUsageBlock({ blockId: selectedUsageBlock.blockId })
                    .then(function () { return dispatch(callGetApiKeys()); })
                    .then(function () {
                    gtmPush("purchase", {
                        currency: "USD",
                        transaction_id: crypto.randomUUID(),
                        value: selectedUsageBlock.finalPrice,
                        items: [
                            {
                                item_id: selectedUsageBlock.blockId,
                                quantity: 1,
                                price: selectedUsageBlock.finalPrice,
                            },
                        ],
                    });
                    dispatch(addSuccessToast("Usage block purchased successfully."));
                    setSelectedUsageBlock(null);
                    setModalError(null);
                })
                    .catch(function (error) {
                    var message = formatErrorMessage(error);
                    setModalError(message);
                    dispatch(addErrorToast(message));
                })];
        });
    }); };
    var onSelectAutoRechargeBlock = function (blockId) {
        dispatch(callPatchAccount({ autoRechargeBlockId: blockId }))
            .unwrap()
            .then(function () {
            return dispatch(addSuccessToast(blockId ? "Auto top-up enabled." : "Auto top-up disabled."));
        })
            .catch(function (error) { return dispatch(addErrorToast(formatErrorMessage(error))); });
    };
    var onManageSubscriptionCancel = function () {
        var method = subscriptionIsCancelled ? postUndoCancelSubscription : postCancelSubscription;
        var successMessage = subscriptionIsCancelled
            ? "Subscription has been reinstated."
            : "Subscription has been cancelled.";
        setIsModalActionLoading(true);
        method()
            .then(function (_a) {
            var data = _a.data;
            dispatch(setSubscription(data));
            dispatch(callGetApiKeys());
            dispatch(addSuccessToast(successMessage));
            closeSubCancelModal();
        })
            .catch(function (error) {
            var message = formatErrorMessage(error);
            setModalError(message);
            dispatch(addErrorToast(message));
        })
            .finally(function () { return setIsModalActionLoading(false); });
    };
    var onPurchaseAddOn = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!selectedAddOn)
                return [2 /*return*/, Promise.resolve()];
            return [2 /*return*/, postPurchaseAddon({ addonId: selectedAddOn.id })
                    .then(function (_a) {
                    var data = _a.data;
                    dispatch(setSubscription(data));
                    gtmPush("purchase", {
                        currency: "USD",
                        transaction_id: crypto.randomUUID(),
                        value: selectedAddOn.price,
                        items: [{ item_id: selectedAddOn.id, quantity: 1, price: selectedAddOn.price }],
                    });
                    dispatch(addSuccessToast("Add-on purchased successfully."));
                    closeAddOnModal();
                })
                    .catch(function (error) {
                    var message = formatErrorMessage(error);
                    setModalError(message);
                    dispatch(addErrorToast(message));
                })];
        });
    }); };
    var onModifyAddOn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isUpgrade, method;
        return __generator(this, function (_a) {
            if (!currentSubAddOn || !selectedAddOn)
                return [2 /*return*/, Promise.resolve()];
            isUpgrade = currentSubAddOn.id === "api_dnc_scrub";
            method = isUpgrade ? postUpgradeAddon : postDowngradeAddon;
            setIsModalActionLoading(true);
            return [2 /*return*/, method()
                    .then(function (_a) {
                    var data = _a.data;
                    dispatch(setSubscription(data));
                    dispatch(addSuccessToast("Add-on updated."));
                    closeAddOnModal();
                })
                    .catch(function (error) {
                    var message = formatErrorMessage(error);
                    setModalError(message);
                    dispatch(addErrorToast(message));
                })
                    .finally(function () { return setIsModalActionLoading(false); })];
        });
    }); };
    var onRemoveAddOn = function () {
        if (!currentSubAddOn)
            return;
        var method = addOnIsCancelled ? postUndoCancelAddon : postCancelAddon;
        var successMessage = addOnIsCancelled
            ? "Add-on has been reinstated."
            : "Add-on has been cancelled.";
        setIsModalActionLoading(true);
        method()
            .then(function (_a) {
            var data = _a.data;
            dispatch(setSubscription(data));
            dispatch(callGetApiKeys());
            dispatch(addSuccessToast(successMessage));
            closeAddOnModal();
        })
            .catch(function (error) {
            var message = formatErrorMessage(error);
            setModalError(message);
            dispatch(addErrorToast(message));
        })
            .finally(function () { return setIsModalActionLoading(false); });
    };
    var isPlanUpgrade = (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.id) === "api_payg" && (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id) === "api_payg_plus";
    var isAddOnUpgrade = (currentSubAddOn === null || currentSubAddOn === void 0 ? void 0 : currentSubAddOn.id) === "api_dnc_scrub";
    return (_jsxs("section", { className: "flex h-full", "data-testid": "account-info", children: [_jsx(SideNav, {}), _jsx("div", { ref: contentRef, className: "w-full overflow-auto px-7 py-6", children: _jsxs("div", { className: "mx-auto max-w-[1220px]", children: [_jsx(Panel, { className: "mb-6 p-5", children: _jsx(OverviewPannel, { userInfo: userInfo, liveKey: liveKey, testKey: testKey, subscription: subscription, currentPlan: currentPlan, subscriptionIsCancelled: subscriptionIsCancelled, hasUsageBlockAccess: hasUsageBlockAccess }) }), _jsxs("div", { className: "grid gap-5 xl:grid-cols-[minmax(0,1fr)_330px] 2xl:grid-cols-[minmax(0,1fr)_360px]", children: [_jsxs("main", { className: "min-w-0 space-y-6", children: [_jsxs("div", { id: "api-keys", children: [_jsx(SectionTitle, { eyebrow: "API keys" }), _jsxs(Panel, { className: "space-y-5", children: [_jsx(ApiKeyPanel, { apiKey: liveKey, title: "Live API Key", label: "Production", locked: !liveKey, showUsageBlocks: hasUsageBlockAccess }), _jsx(ApiKeyPanel, { apiKey: testKey, title: "Test API Key", label: "Sandbox", showUsageBlocks: false })] })] }), _jsxs("div", { id: "plan-options", children: [_jsx(SectionTitle, { eyebrow: "Plan options" }), !isPayingCustomer ? (_jsx("div", { className: "grid gap-5 md:grid-cols-2 xl:grid-cols-3", children: plans === null || plans === void 0 ? void 0 : plans.map(function (plan) { return (_jsx(PlandAndAddonCard, { dbPlan: plan, onClick: function () { return onSelectPlan(plan.id); } }, plan.id)); }) })) : (_jsx("div", { className: "space-y-4", children: planRowIds.map(function (planId) { return (_jsx(PlanRow, { planId: planId, currentPlanId: currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.id, subscriptionIsCancelled: subscriptionIsCancelled, onSelect: onSelectPlan, onCancel: function () {
                                                            setModalError(null);
                                                            setIsSubCancelModalOpen(true);
                                                        } }, planId)); }) }))] }), hasUsageBlockAccess ? (_jsxs("div", { id: "usage-blocks", children: [_jsx(SectionTitle, { eyebrow: "Usage blocks", title: "Need more lookups?" }), activeUsageBlocks.length ? (_jsx(CurrentUsageBlocks, { usageBlocks: activeUsageBlocks })) : null, _jsx(UsageBlocksTable, { blockOptions: usageBlockOptions, autoRechargeBlockId: userInfo.autoRechargeBlockId, showAutoTopUp: true, disabled: !isPayingCustomer, onSelectAutoRechargeBlock: onSelectAutoRechargeBlock, onBuy: function (option) {
                                                        setModalError(null);
                                                        setSelectedUsageBlock(option);
                                                    } }), _jsx("p", { className: "mt-2 text-xs text-mutedBlue", children: "Blocks are added to your account instantly. No expiry \u2014 consumed after your monthly allotment runs out." })] })) : null] }), _jsxs("aside", { className: "min-w-0 space-y-6", children: [_jsx(AccountInfoPannel, { userInfo: userInfo, currentPlan: currentPlan }), _jsxs("div", { children: [_jsx(SectionTitle, { eyebrow: "Preferences" }), _jsx(Panel, { children: _jsx("div", { className: "space-y-5", children: _jsxs("div", { className: "flex items-center justify-between gap-4 border-b border-sherpaCreamier pb-4", children: [_jsxs("div", { children: [_jsx("div", { className: "font-bold text-ink", children: "Communication emails" }), _jsx("div", { className: "text-xs text-mutedBlue", children: "Product status and features updates" })] }), _jsx(Switch, { options: [], checked: !userInfo.emailOptOut, onChange: onToggleOptOut })] }) }) })] }), _jsx(BillingPanel, { userInfo: userInfo, subscription: subscription, hasBillingInfo: hasBillingInfo, subscriptionIsCancelled: subscriptionIsCancelled, onEditBillingInfo: function () { return setIsBillingInfoModalOpen(true); } }), _jsxs("div", { id: "dnc-addons", children: [_jsx(SectionTitle, { eyebrow: "DNC add-ons" }), currentSubAddOnId ? (_jsx("div", { className: "space-y-4", children: addOnOptions === null || addOnOptions === void 0 ? void 0 : addOnOptions.map(function (addOn) { return (_jsx(DncAddOnRow, { addOn: addOn, current: currentSubAddOnId === addOn.id, cancelled: currentSubAddOnId === addOn.id && addOnIsCancelled, disabled: !isPayingCustomer || subscriptionIsCancelled || addOnIsCancelled, onSelect: function () {
                                                            setModalError(null);
                                                            setSelectedAddOn(addOn);
                                                            setSelectedAddOnAction("modify");
                                                        }, onRemove: currentSubAddOnId === addOn.id
                                                            ? function () {
                                                                setModalError(null);
                                                                setSelectedAddOn(addOn);
                                                                setSelectedAddOnAction("remove");
                                                            }
                                                            : undefined }, addOn.id)); }) })) : (_jsx("div", { className: "grid gap-5 md:grid-cols-2 xl:grid-cols-1", children: addOnOptions === null || addOnOptions === void 0 ? void 0 : addOnOptions.map(function (addOn) { return (_jsx(PlandAndAddonCard, { dbPlan: addOn, compact: true, disabled: !isPayingCustomer || subscriptionIsCancelled, onClick: function () {
                                                            setModalError(null);
                                                            setSelectedAddOn(addOn);
                                                            setSelectedAddOnAction("purchase");
                                                        } }, addOn.id)); }) }))] })] })] })] }) }), _jsx(BillingInfoModal, { isOpen: isBillingInfoModalOpen, toggle: function () { return setIsBillingInfoModalOpen(false); }, hasBillingInfo: hasBillingInfo, onSaved: function () { return setHasLocalBillingInfo(true); } }), _jsx(SubscriptionCancelModal, { isOpen: isSubCancelModalOpen, toggle: closeSubCancelModal, subscription: subscription, isCancelled: subscriptionIsCancelled, isLoading: isModalActionLoading, error: modalError, onConfirm: onManageSubscriptionCancel }), _jsx(SubscriptionManageModal, { selectedPlan: selectedPlan, selectedPlanAction: selectedPlanAction, isPlanUpgrade: isPlanUpgrade, isModalActionLoading: isModalActionLoading, modalError: modalError, closePlanModal: closePlanModal, onPurchaseSubscription: onPurchaseSubscription, onModifySubscription: onModifySubscription }), _jsx(UsageBlockManageModal, { selectedUsageBlock: selectedUsageBlock, modalError: modalError, closeUsageBlockModal: closeUsageBlockModal, onPurchaseUsageBlock: onPurchaseUsageBlock }), _jsx(DncAddOnManageModal, { selectedAddOn: selectedAddOn, selectedAddOnAction: selectedAddOnAction, isAddOnUpgrade: isAddOnUpgrade, addOnIsCancelled: addOnIsCancelled, currentSubAddOn: currentSubAddOn, isModalActionLoading: isModalActionLoading, modalError: modalError, closeAddOnModal: closeAddOnModal, onPurchaseAddOn: onPurchaseAddOn, onModifyAddOn: onModifyAddOn, onRemoveAddOn: onRemoveAddOn })] }));
};
export default Account;
